export default "__VITE_ASSET__CIVqaf$W__"